import React, { PureComponent } from 'react';
import mergeClassNames from 'classnames';

class Input extends PureComponent {
    render() {
        const {
            inputRef,
            size,
            ...props
        } = this.props;

        const classNames = mergeClassNames({
            ['form-control']: true
        });

        // Special case for desktop safari: Add placeholder to date fields since there is no datepicker
        if (window.safari !== undefined && props.type === "date") {
            props.placeholder = "JJJJ-MM-TT";
        }

        return (
            <input ref={inputRef} maxlength={size} className={classNames} {...props} />
        );
    }
}

Input.defaultProps = {};

export default Input;
